import React from "react"
import { Button, ButtonProps, IconNext } from "dash-styled"

type NextButtonProps = Omit<ButtonProps, "variant" | "color" | "children">

export function NextButton({ className, ...props }: NextButtonProps) {
    return (
        <Button
            variant="round"
            color="gray"
            size="sm"
            className={`border-white border-rhino-500 text-rhino-200 bg-transparent ${className}`}
            {...props}
        >
            <IconNext size={props.size !== undefined ? props.size : "md"} />
        </Button>
    )
}
